const userProfile = {
  pageTitle: 'Mi perfil',
  toast: {
    success: 'Perfil actualizado correctamente.',
    error: 'Ocurrió un error desconocido.',
  },
  tabs: {
    personalInfo: 'Info Personal',
    security: 'Seguridad',
  },
  form: {
    personalDetails: {
      notice: 'Nota: cierta información puede ser vista para otras personas que usan los servicios de Moovex.',
      title: 'Detalles personales',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Telefono',
      gender: 'Genero',
      genderOptions: {
        male: 'Masculino',
        female: 'Femenino',
        default: 'Preferir no decir / Otro',
      },
      dateOfBirth: 'Fecha de Nacimiento',
    },
    preferences: {
      title: 'Preferencias',
      twoFactorAuth: 'Autentificación de dos factores (2FA)',
      twoFactorAuthWarning: 'Guardar esta configuración puede desconectarlo del sistema, lo que requiere un nuevo inicio de sesión.',
      twoFactorAuthNotice: 'La Política del sitio requiere la Autentificación de dos factores (2FA) y no se puede deshabilitar.',
      twoFactorAuthInfo: 'El tener acceso a los sitios obligados por 2FA puede invalidar esta preferencia.',
    },
    userRoles: {
      title: 'Roles de usuario',
      companyAdmin: 'Administrador de la empresa',
      site: 'Sitio',
      role: 'Función',
    },
    update: 'Actualizar',
  },
  validations: {
    firstName: 'El nombre es obligatorio',
    lastName: 'Apellido es obligatorio',
    phone: {
      invalid: 'El teléfono no es válido',
      required: 'El teléfono es obligatorio',
      length: 'El teléfono debe contener de 6 a 16 dígitos',
    },
    email: {
      required: 'El correo electrónico es obligatorio',
      email: 'Dirección de correo electrónico no válida',
    },
  },
};

export default userProfile;
